import type { RedirectLocaleConfig } from "../shared/index.js";

/** Multi language config for redirect popup */
export const redirectLocales: RedirectLocaleConfig = {
  "/en/": {
    name: "English",
    hint: "Your primary language is $1, do you want to switch to it?",
    switch: "Switch to $1",
    cancel: "Cancel",
  },

  "/zh/": {
    name: "简体中文",
    hint: "您的首选语言是 $1，是否切换到该语言？",
    switch: "切换到 $1",
    cancel: "取消",
  },

  "/zh-tw/": {
    name: "繁體中文",
    hint: "您的首選語言是 $1，是否切換到該語言？",
    switch: "切換到 $1",
    cancel: "取消",
  },

  "/de/": {
    name: "Deutsch",
    hint: "Ihre bevorzugte Sprache ist $1, möchten Sie zu dieser wechseln?",
    switch: "Zu $1 wechseln",
    cancel: "Abbrechen",
  },

  "/de-at/": {
    name: "Deutsch (Österreich)",
    hint: "Ihre bevorzugte Sprache ist $1, möchten Sie zu dieser wechseln?",
    switch: "Zu $1 wechseln",
    cancel: "Abbrechen",
  },

  "/vi/": {
    name: "Tiếng Việt",
    hint: "Ngôn ngữ chính của bạn là $1, bạn có muốn chuyển sang nó?",
    switch: "Chuyển sang $1",
    cancel: "Hủy",
  },

  "/uk/": {
    name: "Українська",
    hint: "Вашою основною мовою є $1, чи бажаєте ви переключитися на неї?",
    switch: "Переключитися на $1",
    cancel: "Скасувати",
  },

  "/ru/": {
    name: "Русский",
    hint: "Ваш основной язык - $1, вы хотите переключиться на него?",
    switch: "Переключиться на $1",
    cancel: "Отмена",
  },

  "/br/": {
    name: "Português (Brasil)",
    hint: "A língua principal é $1, deseja mudar para ela?",
    switch: "Mudar para $1",
    cancel: "Cancelar",
  },

  "/pl/": {
    name: "Polski",
    hint: "Twoim głównym językiem jest $1, czy chcesz przełączyć się na niego?",
    switch: "Przełącz na $1",
    cancel: "Anuluj",
  },

  "/sk/": {
    name: "Slovenčina",
    hint: "Vašou hlavnou jazykom je $1, chcete prepnúť naň?",
    switch: "Prepnúť na $1",
    cancel: "Zrušiť",
  },

  "/fr/": {
    name: "Français",
    hint: "Votre langue principale est $1, voulez-vous la changer ?",
    switch: "Changer pour $1",
    cancel: "Annuler",
  },

  "/tr/": {
    name: "Türkçe",
    hint: "Ana diliniz $1, ona geçmek ister misiniz?",
    switch: "$1'e geç",
    cancel: "İptal",
  },

  "/fi/": {
    name: "Suomi",
    hint: "Pääkielenäsi on $1, haluatko vaihtaa siihen?",
    switch: "Vaihda $1:een",
    cancel: "Peruuta",
  },

  "/hu/": {
    name: "Magyar",
    hint: "A fő nyelvét $1, szeretné váltani?",
    switch: "Váltás $1",
    cancel: "Mégse",
  },

  "/id/": {
    name: "Bahasa Indonesia",
    hint: "Bahasa utama Anda adalah $1, apakah Anda ingin beralih ke sana?",
    switch: "Beralih ke $1",
    cancel: "Batal",
  },

  "/nl/": {
    name: "Nederlands",
    hint: "Uw primaire taal is $1, wilt u overschakelen?",
    switch: "Overschakelen naar $1",
    cancel: "Annuleren",
  },

  "/ja/": {
    name: "日本語",
    hint: "あなたの主要な言語は $1 です。それに切り替えますか？",
    switch: "$1 に切り替える",
    cancel: "キャンセル",
  },

  "/ko/": {
    name: "한국어",
    hint: "당신의 기본 언어는 $1입니다. 그것으로 전환 하시겠습니까?",
    switch: "$1로 전환",
    cancel: "취소",
  },

  "/es/": {
    name: "Español",
    hint: "Su idioma principal es $1, ¿desea cambiarlo?",
    switch: "Cambiar a $1",
    cancel: "Cancelar",
  },

  "/pt/": {
    name: "Português",
    hint: "Sua língua principal é $1, deseja mudar para ela?",
    switch: "Mudar para $1",
    cancel: "Cancelar",
  },
};
